import { render, staticRenderFns } from "./TwoFactorUsageSetting.vue?vue&type=template&id=14eb366e&scoped=true"
import script from "./TwoFactorUsageSetting.vue?vue&type=script&lang=ts"
export * from "./TwoFactorUsageSetting.vue?vue&type=script&lang=ts"
import style0 from "./TwoFactorUsageSetting.vue?vue&type=style&index=0&id=14eb366e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14eb366e",
  null
  
)

export default component.exports